import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import { AssetFile } from 'contentful';
import { TypeSectionQuoteFields } from '../../../models/contentful-content-types/section-quote';
import { ScrollSectionDirective } from '../../utils/directives/scroll-section.directive';

@Component({
  imports: [CommonModule, FontAwesomeModule, ScrollSectionDirective],
    selector: 'jnguyen-section-quote',
    templateUrl: './section-quote.component.html',
    styleUrls: ['./section-quote.component.scss'],
})
export class SectionQuoteComponent {
  @Input() data: TypeSectionQuoteFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

   getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
